import React from 'react'

import styles from './viewLayout.module.css';

export const ViewLayout = ({className = '', children, ...props}) => {
    return <div className={styles.ViewLayout + ' ' + className} {...props}>
        {children}
    </div>
}